<tt-page class="col-xs-12 col-md-4 sp-0">
    <tt-card>
        <tt-button-goto ttText="edidestinations_new" ttGoto="edidestination" [ttGotoParms]="{ edi_destination_keyno: '0' }" ttIcon="far fa-plus"></tt-button-goto>
    </tt-card>

    <tt-list [ttData]="itemsListEdiDestinations"></tt-list>
</tt-page>
